import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import fieldKeys from './fieldKeys';

export default {
    [fieldKeys.ITEM_NOT_AVAILABLE]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.unavailable_shipping"
            defaultMessage="Because this item is not available for purchase, we are unable to complete your request for a shipping quote at this time."
        />
    ),
    [fieldKeys.DUPLICATE_REQUEST]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.duplicate_request"
            defaultMessage="A shipping quote has already been requested on this item."
        />
    ),
    [fieldKeys.SHIPPING_QUOTE_RECEIVED]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.shipping_quote_received"
            defaultMessage="You have already received a shipping quote for this item."
        />
    ),
    [fieldKeys.SYSTEM_ERROR]: (
        <FormattedHTMLMessage
            id="dc.bulkRequestSuccessModal.shipping.system_error"
            defaultMessage={`An error occurred processing your shipping quote request. Please try again later or contact <a href="mailto:trade@1stdibs.com">trade@1stdibs.com</a> for assistance.`}
        />
    ),
    [fieldKeys.ITEM_ON_HOLD]: (
        <FormattedHTMLMessage
            id="dc.bulkRequestSuccessModal.shipping.onhold_for_another_buyer"
            defaultMessage="Because this item is on hold for another buyer, we are unable to complete your request for a shipping quote at this time."
        />
    ),
    [fieldKeys.CHECKOUT_COMPLETE]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.checkout_complete"
            defaultMessage="You have already checked out on this item."
        />
    ),
    [fieldKeys.GENERAL_INQUIRY]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.shipping.general_inquiry"
            defaultMessage="A shipping quote cannot be provided as part of a general inquiry to a seller."
        />
    ),
};
